const colorThemes = document.querySelectorAll('[name="theme"]');
const images = document.querySelectorAll('.img-theme');

/**
 * displays images for given theme
 * hides all images for other themes
 * @param {string} theme light, dark or contrast
 */
const changeImgTheme = function(theme) {
    images.forEach(img => {
        const imgTheme = img.dataset.theme;
    
        if(imgTheme === theme) img.classList.remove('hidden');
        else img.classList.add('hidden');
    });
}

/*
    if you want an image to change with the theme implement it like this:

    <img src="..." data-theme="light" class="img-theme">
    <img src="..." data-theme="dark" class="img-theme hidden">
    <img src="..." data-theme="contrast" class="img-theme hidden">
*/

/**
 * stores theme in local storage if cookies where accepted
 * 
 * @param {string} theme light, dark or contrast
 */
const storeTheme = function(theme) {
    if(localStorage.getItem("consent") == "true") {
        localStorage.setItem("theme", theme);
    }
};

/**
 * gets theme from local storage
 * checks corresponding radio button in theme changer
 * changes body class
 */
const setTheme = function() {
    const activeTheme = localStorage.getItem("theme");
    colorThemes.forEach((themeOption) => {
        if(themeOption.id === activeTheme) {
            themeOption.checked = true;
        }
    });
    document.documentElement.className = activeTheme;
    changeImgTheme(activeTheme);
};

/*
    When you click on theme radio button
    store theme and change body class
*/
colorThemes.forEach((themeOption) => {
    themeOption.addEventListener('click', () => {
        storeTheme(themeOption.id);
        document.documentElement.className = themeOption.id;
        changeImgTheme(themeOption.id);
    });
});

// applying the theme on page load
document.onload = setTheme();